import { compose } from 'recompose';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import {
  selectDependentFormAssigmentId,
  selectDependentFormGeneralInfoErrors,
  selectDependentFormUserData,
  selectDependentFormDependent,
  selectDependentFormRegistrationSteps,
} from '../../../redux/dependentForm/selectors';
import {
  selectCountryOptions,
  selectUsStates,
} from '../../../redux/data/selectors';
import * as assignmentFetch from '../../../redux/dependentForm/assignment-fetch-req';
import styles from '../styles.styl';

const mapStateToProps = state => ({
  assignmentId: selectDependentFormAssigmentId(state),
  dependentInfo: selectDependentFormUserData(state),
  dataValidationErrors: selectDependentFormGeneralInfoErrors(state),
  dependent: selectDependentFormDependent(state),
  registrationSteps: selectDependentFormRegistrationSteps(state),
  statesList: selectUsStates(state),
  countryList: selectCountryOptions(state),
});

const mapDispatchToProps = {
  fetchAssignment: assignmentFetch.actions.send,
  clearAssignment: assignmentFetch.actions.clear,
};

export const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/DependentForm/DependentGeneralInfo/enhance.js